import { useEffect, useRef, useState } from 'react'
import { CircularProgress, Grid } from '@material-ui/core'
import LimitTagsSelect from '../../../components/atomComponents/selects/limitTagsSelectAutoComplete'
import { getRegionsByBusinessUnits } from '../../../services/servicesDefinitions'
import { useStyles } from '../../services/styles'
import AsyncAutoComplete from '../../../components/atomComponents/selects/asyncAutoComplete'
import { providersByUserShort } from '../../../services/ProviderServices'
import { selectsName } from './constants'

const ZonesForm = props => {
  const classes = useStyles()
  const {
    control,
    watch,
    setValue,
    regions,
    setRegions,
    handleSelectedZone,
    handleSelectedProvider,
    setSelectedAll,
    selectedAll,
    dataBUList,
    loadingBu,
  } = props
  const [loadingRegions, setLoadingRegions] = useState(false)
  const debounceRef = useRef(null)
  const isMounted = useRef(false)
  const zoneSelected = watch(selectsName.regionListCtrl)
  const providerSelected = watch(selectsName.proListCtrl)
  const busSelected = watch(selectsName.buListId)

  useEffect(() => {
    zoneSelected && handleSelectedZone(zoneSelected)
  }, [zoneSelected])

  useEffect(() => {
    providerSelected && handleSelectedProvider(providerSelected)
  }, [providerSelected])

  const handleSelectedBUs = () => {
    if (!busSelected || busSelected.length === 0) return

    // test-logs
    console.log('busSelected', busSelected)
  }

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true
      return
    }

    setRegions([])
    setValue(selectsName.regionListCtrl, null)
    if (debounceRef.current) clearTimeout(debounceRef.current)
    if (busSelected && busSelected.length > 0) {
      debounceRef.current = setTimeout(() => {
        handleSelectedBUs()

        fetchCountryRegion()
      }, 1000)
    }
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current)
    }
  }, [JSON.stringify(busSelected)])

  const fetchCountryRegion = async () => {
    setLoadingRegions(true)
    const res = await getRegionsByBusinessUnits(busSelected)
    if (res?.data) {
      const regions = res.data.map(item => ({
        value: item.cityId,
        label: `${item.cityName} - ${item.countryName}`,
        country: item.countryId,
        countryName: item.countryName,
      }))
      setRegions(regions)
    }
    setLoadingRegions(false)
  }
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6}>
          <LimitTagsSelect
            data={dataBUList}
            id={selectsName.buListId}
            limitTags={2}
            inputLabel={'Unidades de negocio'}
            required={true}
            control={control}
            multiple={true}
            labelSelectAll={'Seleccionar todo'}
            overwriteClasses={{
              option: classes.overwriteOption,
            }}
            OverwriteInputProps={params => ({
              ...params.InputProps,
              endAdornment: (
                <>
                  {loadingBu ? (
                    <CircularProgress color="inherit" size={22} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <LimitTagsSelect
            data={regions}
            id={selectsName.regionListCtrl}
            limitTags={2}
            inputLabel={'Region'}
            required={true}
            control={control}
            multiple={true}
            labelSelectAll={'Seleccionar todo'}
            overwriteClasses={{
              option: classes.overwriteOption,
            }}
            OverwriteInputProps={params => ({
              ...params.InputProps,
              endAdornment: (
                <>
                  {loadingRegions ? (
                    <CircularProgress color="inherit" size={22} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            })}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ paddingTop: '15px' }}>
        <Grid item xs={12} sm={6} md={6}>
          <AsyncAutoComplete
            name={selectsName.proListCtrl}
            control={control}
            label={'Proveedores'}
            placeholder={'Seleccione los proveedores'}
            variant={'outlined'}
            required={true}
            helperText={'Seleccione los proveedores'}
            multiple={true}
            cbEndpoint={providersByUserShort}
            setSelectedAll={setSelectedAll}
            selectedAll={selectedAll}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default ZonesForm
